import { InfoConsultationContainer } from '../containers/InfoConsultationContainer/index'

export const InfoConsultationPage = () => (
    <InfoConsultationContainer/>
)